export default {
  paymentFormErrorTitle: {
    id: 'express_replacement_payment_form_error_title',
    defaultMessage: 'Unable to process card hold',
  },
  paymentFormErrorContent: {
    id: 'express_replacement_payment_form_error_content',
    defaultMessage:
      'Something went wrong, but you won’t be charged. Try a different card, or {link, html}',
  },
  paymentFormErrorLink: {
    id: 'express_replacement_payment_form_error_link',
    defaultMessage: 'get help another way.',
  },
  paymentFormTcCheckbox: {
    id: 'express_replacement_payment_form_tc_checkbox',
    defaultMessage:
      'I agree to the {tc, html} of Express Replacement and to a hold on my card.',
  },
  paymentFormTcCheckboxLink: {
    id: 'express_replacement_payment_form_tc_checkbox_link',
    defaultMessage: 'Terms and Conditions',
  },
  paymentFormSubmitButton: {
    id: 'express_replacement_payment_form_submit_button',
    defaultMessage: 'Order Express Replacement',
  },
  paymentFormPciDss: {
    id: 'express_replacement_payment_form_pci_dss',
    defaultMessage:
      'Your credit card details are protected by our PCI-DSS certified payment provider. They are the only entity with access to the data provided, required in order to process payments, and validate and manage credit card guarantees. {link, html}',
  },
  paymentFormPciDssLink: {
    id: 'express_replacement_payment_form_pci_dss_link',
    defaultMessage: 'Read more in our data protection policy',
  },
}
